import { NavigationGuardNext, Route } from 'vue-router';

type Guard = (
  to: Route,
  from: Route,
  next: NavigationGuardNext,
) => void;

const evaluateGuards = (guards: Array<Guard>, to: Route, from: Route, next: NavigationGuardNext) => {
  const guardsLeft = guards.slice(0);
  const nextGuard = guardsLeft.shift();

  if (nextGuard === undefined) {
    next();
    return;
  }

  nextGuard(to, from, nextArg => {
    if (nextArg === undefined) {
      evaluateGuards(guardsLeft, to, from, next);
      return;
    }

    next(nextArg);
  });
};

export const multiguard = (guards: Array<Guard>) => {
  if (!Array.isArray(guards)) {
    throw new Error('You must specify an array of guards');
  }

  return (to: Route, from: Route, next: NavigationGuardNext) => {
    return evaluateGuards(guards, to, from, next);
  };
};
